import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';

import Modal from '../../common/modal/Modal';
import Card from '../../common/card/Card';
import Form from '../../common/form/Form';
import Button from '../../common/button/Button';
import Input from '../../common/input/Input';
import Icon from '../../common/icon/Icon';

import Api from '../../../../utils/api';

require('./style.scss');

const RATING_ICON_MAPPING = new Map();
RATING_ICON_MAPPING.set(1, '/static/images/rating_1star.png');
RATING_ICON_MAPPING.set(2, '/static/images/rating_2star.png');
RATING_ICON_MAPPING.set(3, '/static/images/rating_3star.png');
RATING_ICON_MAPPING.set(4, '/static/images/rating_4star.png');
RATING_ICON_MAPPING.set(5, '/static/images/rating_5star.png');

const FIELD_MAPPING = {
  full_name: 'Full name',
  non_field_errors: 'Errors',
  otp: 'OTP',
  phone_number: 'Phone number',
  rating: 'Rating',
};

const REVIEW_STATUS = {
  draft: 'draft',
  otpSend: 'otp-send',
  complete: 'complete',
};

export default class WriteAReview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRatingDropDown: false,
      reviewStatus: REVIEW_STATUS.draft,

      fullName: '',
      phoneNumber: '',
      otp: '',
      requestId: null,
      rating: null,
      review: '',

      errors: {},
    };
  }

  onSubmitOtpClick() {
    this.postReview(
      this.state.fullName,
      this.state.phoneNumber,
      this.state.rating,
      this.state.requestId,
      this.state.otp,
      this.state.review);
  }

  cleanUpOnClose() {
    this.setState({
      errors: {},
      fullName: '',
      phoneNumber: '',
      otp: '',
      requestId: null,
      rating: null,
      review: '',
      reviewStatus: REVIEW_STATUS.draft,
      showRatingDropDown: false,
      title: '',
    });

    this.props.onClose();
  }

  generateOtp(phoneNumber) {
    Api.generateOtp(phoneNumber)
      .then(response => this.setState({
        reviewStatus: REVIEW_STATUS.otpSend,
        requestId: response.request_id,
        isInputDisabled: true,
        errors: {},
      }))
      .fail(error => this.setState({ errors: JSON.parse(error.response) }));
  }

  postReview(fullName, phoneNumber, rating, requestId, otp, review) {
    Api.addReview(this.props.code, {
      'request-id': requestId,
      otp,
    }, JSON.stringify({
      full_name: fullName,
      phone_number: phoneNumber,
      rating,
      source: 'member',
      review: review || null,
    }))
      .then(() => this.cleanUpOnClose())
      .fail(error => this.setState({ errors: JSON.parse(error.response) }));
  }

  renderOtpBox() {
    return (
      <div className="row form-group">
        <div className="col-md-10">
          <Input
            type="number"
            placeholder="OTP"
            defaultValue=""
            onBlur={event => this.setState({ otp: event.target.value })}
            fullWidth
          />
        </div>

        <div className="col-md-14">
          <Button.Group>
            <Button
              label="Submit"
              leftIcon={<Icon name="check" />}
              onClick={() => this.onSubmitOtpClick()}
              primary
              disabled={this.state.review === ''}
            />

            <Button
              label="Resend OTP"
              leftIcon={<Icon name="refresh" />}
              onClick={() => this.generateOtp(this.state.phoneNumber)}
            />
          </Button.Group>
        </div>
      </div>
    );
  }

  renderSmiley(rating, selectedRating) {
    return (
      <span
        key={rating}
        className={Classnames(
          'review-rating-smiley-box', {
            selected: rating === selectedRating,
          })}
        onClick={() => this.setState({
          rating,
          showRatingDropDown: false,
        })}
      >
        {rating ?
          <span className="review-rating-icon">
            <img
              alt={`Rating ${rating}`}
              src={RATING_ICON_MAPPING.get(rating)}
            />
          </span> : 'Select Rating' }
      </span>);
  }

  renderRatingBox() {
    const selectedRating = this.state.rating;

    return (
      <div id="rating-bar">
        <div className="hidden-md hidden-lg rating-dropdown">
          <div
            className="review-rating-smiley-box selected"
            onClick={() => this.setState({
              showRatingDropDown: !this.state.showRatingDropDown,
            })}
          >
            {selectedRating ? 'Rating ' : null}
            {this.renderSmiley(selectedRating, selectedRating)} <Icon name="caret-down" />
          </div>

          {this.state.showRatingDropDown ?
            <div className="review-rating-dropdown">
              {[5, 4, 3, 2, 1].map(number =>
                this.renderSmiley(number, this.state.rating))}
            </div> : null}
        </div>

        <div className="hidden-sm hidden-xs">
          <span className="review-rating-smiley-box select-rating">
            Select Rating
          </span>

          {[5, 4, 3, 2, 1].map(number =>
            this.renderSmiley(number, this.state.rating))}
        </div>
      </div>);
  }

  render() {
    return (
      <Modal open={this.props.open} onClose={() => this.cleanUpOnClose()}>
        <div className="write-review-modal">
          <Card>
            <Card.Content>
              <Card.Header
                media={<img alt="Write a review" src="/static/images/write_a_review.png" />}
                title="Write a review"
              />

              <Card.Body>
                {WriteAReview.renderErrors(this.state.errors)}
                {this.state.review === '' && this.state.reviewStatus === 'otp-send' ?
                  <p style={{ fontSize: '1rem' }}><strong>Review:</strong>This field may not be blank</p> : ''}

                <Form>
                  <div className="row form-group">
                    <div className="col-md-12">
                      <Input
                        placeholder="Full Name"
                        defaultValue=""
                        onBlur={event => this.setState({ fullName: event.target.value })}
                        fullWidth
                        rounded
                      />
                    </div>
                    <div className="col-md-12">
                      <Input
                        type="tel"
                        placeholder="(+91) Mobile number"
                        defaultValue=""
                        onBlur={event => this.setState({ phoneNumber: event.target.value })}
                        fullWidth
                        rounded
                      />
                    </div>
                  </div>

                  <div className="row form-group">
                    <div className="col-lg-24">
                      {this.renderRatingBox()}
                    </div>
                  </div>

                  <div className="row form-group">
                    <div className="col-lg-24">
                      <Input
                        placeholder="Write your review"
                        defaultValue=""
                        onBlur={event => this.setState({ review: event.target.value })}
                        fullWidth
                        multiline
                      />
                    </div>
                  </div>

                  <div className="row text-center">
                    <Button
                      label="Post Review"
                      leftIcon={<Icon name="paper-plane" />}
                      onClick={() => this.generateOtp(this.state.phoneNumber)}
                    />
                  </div>

                  {this.state.reviewStatus === REVIEW_STATUS.otpSend ? this.renderOtpBox() : null}
                </Form>
                <h5 className="review-instruction">Refresh page to see your review</h5>
              </Card.Body>
            </Card.Content>
          </Card>
        </div>
      </Modal>
    );
  }
}

WriteAReview.renderErrors = (errors) => {
  const errorFields = _.keys(errors);
  if (_.size(errorFields) <= 0) {
    return null;
  }

  const errorList = [];

  _.each(errorFields, (field) => {
    if (!(field in FIELD_MAPPING)) {
      return;
    }

    errorList.push(
      <p key={field} style={{ fontSize: '1rem' }}>
        <strong>{FIELD_MAPPING[field]}</strong>: {
          _.join(_.map(errors[field], error =>
            _.isObject(error) ? error.error_message : error), ' ')}
      </p>);
  });

  return _.size(errorList) > 0 ?
    <div className="write-review-modal-errors">
      {errorList}
    </div> : null;
};

WriteAReview.propTypes = {
  code: PropTypes.number,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/derived/modal/WriteAReview.jsx